<script setup>
import { computed } from 'vue';
import CardTypeIcon from './CardTypeIcon.vue';
import CardPriority from './CardPriority.vue';
import CardDueDate from './CardDueDate.vue';
import CardAssignees from './CardAssignees.vue';
import CardStatusBadge from './CardStatusBadge.vue';
import CardPropertyCode from './CardPropertyCode.vue';

const props = defineProps({
  card: { type: Object, required: true },
  statusLabels: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['open']);

const contactName = computed(() => props.card.contacts[0]?.name);
// The task that opened the card says what kind of card it is ("Solicitação de visita").
const kind = computed(() => props.card.task_summary.first);
</script>

<template>
  <article
    class="flex flex-col gap-2 p-3 border rounded-lg cursor-pointer select-none bg-n-solid-2 border-n-weak hover:border-n-strong"
    :data-card-id="card.id"
    @click="emit('open', card)"
  >
    <div class="flex items-center gap-1.5 text-xs text-n-slate-11">
      <CardTypeIcon :icon="kind?.type_icon" class="!size-3.5" />
      <span v-if="kind?.type_name" class="truncate">{{ kind.type_name }}</span>
      <CardPropertyCode
        v-if="card.property_code"
        :code="card.property_code"
        class="ltr:ml-auto rtl:mr-auto"
      />
      <span
        class="text-n-slate-10"
        :class="{ 'ltr:ml-auto rtl:mr-auto': !card.property_code }"
      >
        #{{ card.id }}
      </span>
    </div>
    <h3
      class="mb-0 text-sm font-medium leading-5 text-n-slate-12 line-clamp-2"
      :class="{ 'line-through !text-n-slate-11': card.status === 'resolved' }"
    >
      {{ card.name }}
    </h3>
    <div
      v-if="contactName"
      class="flex items-center gap-1.5 text-xs text-n-slate-11"
    >
      <span class="flex-shrink-0 i-lucide-user-round size-3.5" />
      <span class="truncate">{{ contactName }}</span>
    </div>
    <div class="flex items-center gap-2 pt-1">
      <CardPriority :priority="card.priority" />
      <CardDueDate :card="card" />
      <CardAssignees
        :assignees="card.assignees"
        :size="18"
        class="ltr:ml-auto rtl:mr-auto"
      />
    </div>
    <!-- Only closed cards carry a badge: the board shows open ones unless filtered. -->
    <CardStatusBadge
      v-if="card.status !== 'open'"
      :status="card.status"
      :labels="statusLabels"
      class="self-start"
    />
  </article>
</template>
